import { Timestamp } from 'firebase/firestore';

/**
 * `babyBirthDate` (Firestore Timestamp, doğum ayının 1'i) ile bugünü kıyaslayarak
 * tamamlanmış ay sayısını döndürür (örn. 14).
 */
export function getBabyAgeInMonths(babyBirthDate: Timestamp, now: Date = new Date()): number {
  const birth = babyBirthDate.toDate();
  const y1 = birth.getFullYear();
  const m1 = birth.getMonth();
  const d1 = birth.getDate();
  const y2 = now.getFullYear();
  const m2 = now.getMonth();
  const d2 = now.getDate();

  let months = (y2 - y1) * 12 + (m2 - m1);
  if (d2 < d1) {
    months -= 1;
  }
  return Math.max(0, months);
}

/** Örn. 14 → "14 aylık" */
export function formatBabyAgeMonthsLabel(months: number): string {
  return `${months} aylık`;
}

/**
 * "Tam N aylık" bebek için referans doğum tarihi (ayın 1'i), bugünden N ay geriye.
 * Genel arama (hedef ay sayısı) sorgularında kullanılır.
 */
export function referenceBirthTimestampForCompletedAgeMonths(
  ageMonths: number,
  now: Date = new Date(),
): Timestamp {
  const d = new Date(now.getFullYear(), now.getMonth(), 1);
  d.setMonth(d.getMonth() - ageMonths);
  return Timestamp.fromDate(d);
}

/** Yakın yaş grubu aralığı için Timestamp sınırları (±marginMonths) */
export function babyBirthDateRangeForAgeMatch(
  referenceBirth: Timestamp,
  marginMonths: number,
): { start: Date; end: Date } {
  const ref = referenceBirth.toDate();
  const start = new Date(ref);
  start.setMonth(start.getMonth() - marginMonths);
  const end = new Date(ref);
  end.setMonth(end.getMonth() + marginMonths);
  return { start, end };
}
